<div class="entity"
     *ngIf="entity"
     [ngClass]="[isCollapsable && isCollapsed === true ? 'is-collapsed' : 'is-expanded', isCollapsable === true ? 'is-collapsable' : 'not-collapsable']">
  <div class="entity__main">
    <span *ngIf="entity.followUp || entity.activeFollowUp?.active"
          class="followup-flag--corner"
          (click)="showFollowUpDetailsClick($event)"
          title="Entity is flagged for follow-up">
      <i class="fas fa-fw fa-flag"></i>
    </span>
    <span class="sticker--entity-type">
      <i class="fal fa-{{entity.entityType.icon}} txt-12 mr-0037"
         *ngIf="entity.entityType.icon"></i>{{entity.entityType?.nameSingular}}
    </span>

    <div class="entity__header">
      <app-entity-avatar [assessmentLevel]="entity.currentAssessmentLevel"
                         [spotlightIcon]="entity.spotlightIcon"
                         [entityTypeId]="entity.entityTypeId"
                         [isUser]="entity.linkedUserId"
                         [entityId]="entity.id"
                         [campaignId]="entity.campaignContextId"
                         size="lg">
      </app-entity-avatar>
      <h2 class="h2 entity__detail">
        <a class="entity__name c-pointer"
           title="Go to profile"
           [routerLink]="['/entity/view', entity.id]"
           [queryParams]="{campaignId: campaignId}">{{entity | fullName }}</a>
        <button mat-icon-button
                aria-label="Toggle Details"
                (click)="onToggleCollapsedClick(!isCollapsed)"
                *ngIf="isCollapsable === true"
                class="toggle-button">
          <mat-icon fontSet="fal fa-fw"
                    [fontIcon]="isCollapsed === true ? 'fa-chevron-down' : 'fa-chevron-up'"></mat-icon>
        </button>
        <app-highlighted-topline [targetType]="'Entity'"
                                 [targetId]="entity?.id"
                                 [parentEntityId]="entityId"
                                 [campaignId]="entity?.campaignContextId"
                                 [topline]="entity?.appliedToplines?.item0"></app-highlighted-topline>
        <!-- <span class="entity__location">
          {{entity?.bestAddress | cityState}}
        </span> -->
        <app-entity-contact-buttons class="d-flex"
                                    [entityId]="entity.id"
                                    [campaignId]="entity.campaignContextId"
                                    [ngClass]="{'d-none' : isCollapsed === true}">
        </app-entity-contact-buttons>
      </h2>
    </div>

    <div class="tabs-wrapper"
         [ngClass]="isCollapsable === true && isCollapsed === true ? 'd-none' : 'd-block'">
      <mat-tab-group class="mat-tab-group--traditional"
                     [selectedIndex]="selectedTabIndex"
                     (selectedTabChange)="onSelectedTabChange($event)"
                     mat-stretch-tabs="false"
                     mat-align-tabs="start">
        <mat-tab>
          <ng-template mat-tab-label>
            <span class="ab-tab-link-text">Profile</span>
          </ng-template>
          <app-entity-toplines [entityId]="entity.id"
                               [campaignId]="entity.campaignContextId"
                               class="toplines flex flexAlign--baseline"></app-entity-toplines>
          <app-entity-action-box [entityId]="entity.id"
                                 [campaignId]="entity.campaignContextId"
                                 [showRemove]="false"
                                 class="d-block">
          </app-entity-action-box>
        </mat-tab>

        <mat-tab *ngIf="defaultConnectionCount?.activeConnectionsCount > 0">
          <ng-template mat-tab-label>
            <span class="ab-tab-link-text">Connections</span>
            <span class="badge badge--circle badge--md color--white bg-color--navy ml-0025">
              {{defaultConnectionCount?.activeConnectionsCount || 0}}
            </span>
          </ng-template>


          <mat-nav-list class="connections">
            <mat-list-item *ngFor="let entity of connectedEntities; first as isFirst"
                           class="connection pt-0050 pb-0050"
                           [ngStyle]="!isFirst ? {'border-top': '1px solid #DDE0EB'} : {}"
                           [routerLink]="['/entity/view', entity.id]"
                           queryParamsHandling="preserve">

              <app-assessment-circle class="mr-0100 p-0012"
                                     [level]="entity.currentAssessmentLevel || 0"
                                     [spotlightIcon]="entity.spotlightIcon"
                                     [entityTypeId]="entity.entityTypeId"
                                     [size]="'sm'"></app-assessment-circle>
              <strong class="truncate txt-15">{{entity | fullName}}</strong>
            </mat-list-item>
          </mat-nav-list>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
  <!-- Project additonal content -->
  <ng-content></ng-content>
</div>
